export enum CandidateJob {
	Teacher = 'teacher',
	Assistant = 'assistant',
	Approved = 'approved',
	Denied = 'denied',
	Pending = 'pending',
}